import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDescending = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 18,
	viewBox: "0 0 12 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.82199 16.8136C6.42431 17.3876 5.57569 17.3876 5.178 16.8136L1.89123 12.0695C1.43175 11.4063 1.9064 10.5 2.71322 10.5L9.28678 10.5C10.0936 10.5 10.5683 11.4063 10.1088 12.0695L6.82199 16.8136Z",
		fill: "#282828"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.17801 1.18645C5.57569 0.61244 6.42431 0.61244 6.822 1.18645L10.1088 5.9305C10.5683 6.59371 10.0936 7.5 9.28678 7.5L2.71322 7.5C1.9064 7.5 1.43175 6.59371 1.89123 5.9305L5.17801 1.18645Z",
		fill: "#cacbcf"
	})]
});
export default SvgDescending;
